import { Component, OnInit } from '@angular/core';
//Services
import { RouterService } from 'src/app/services/router/router.service';
import { AdressService } from 'src/app/services/address/adress.service';
import { LanguagesService } from '../../../services/languagesService/languages.service';
//Interfaces
import { IPageProfile } from 'src/app/interfaces/ILangs';
import { UtilsService } from '../../../services/utils/utils.service';
import { TagsService } from 'src/app/services/tags/tags.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { ProfileDetailPage } from '../profile-detail/profile-detail.page';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  isDesktop = false;
  iconSvg: any;
  loader: boolean = true;
  LOADER_ID = 'profile';
  adressLenght: any;
  points: any;
  // texts IU for language
  textsIUProfile: IPageProfile;
  constructor(
    private routerService: RouterService,
    private adressService: AdressService,
    public languageService: LanguagesService,
    private utilsService: UtilsService,
    private tagsService: TagsService,
    public alertService: AlertService,
    private platform: Platform
  ) {}
  ngOnInit() {
    if (this.platform.is('desktop')) {
      this.isDesktop = true;
    }
    this.tagsService.setEventTag(
      'profile_page',
      'profile_screen_viewed',
      false,
      true
    );
    this.utilsService.getUserPoints().then((result: any) => {
      this.points = result;
    });
  }

  // @TODO obtener el componente
  getComponent(name: string) {
    switch (name) {
      case 'ProfileComponent':
        return 'profiledetail';
      case 'OrdersPage':
        return 'orders';
      case 'MapPage':
        return 'map';
      case 'HistoryPointsPage':
        return 'history';
      case 'ProfileConfigPage':
        return 'configuracion';
      case 'RecognitionsPage':
        return 'recognitions';
      default:
        return ProfileDetailPage;
    }
  }

  redirectTo(url: string, id: number, component: string) {
    this.setTags(id);
    if (this.isDesktop) {
      // @TODO Abrir componentes en popups en web o ir a una ruta especifica
      const componentName = this.getComponent(component);

      if (componentName == 'configuracion') {
        this.routerService.redirect('/app/profile/config');
      } else if (componentName == 'recognitions') {
        this.routerService.redirect('/app/recognitions');
      } else if (componentName == 'profiledetail') {
        this.routerService.redirect('/app/profile/profile-detail');
      } else if (componentName == 'map') {
        this.routerService.redirect('/app/map/list');
      } else if (componentName == 'history') {
        this.routerService.redirect('/app/profile/history-points');
      } else if (componentName == 'orders') {
        this.routerService.redirect('/app/orders');
      } else {
        this.routerService.openPopup(
          componentName,
          'gnx-modal',
          null,
          null,
          'modalConfig'
        );
      }
    } else {
      this.routerService.redirect(url);
    }
  }
  redirectToAdress() {
    this.routerService.redirect('map/places');
  }
  async getLenghtAdress() {
    (await this.adressService.getAllAdress()).subscribe((info: any) => {
      this.adressLenght = info.adress.length;
    });
  }
  get getTextIUProfile() {
    this.languageService.textsIU.page_profile.items.map((item) => {
      // @TODO Selecciona el icono
      switch (item.id) {
        case 1:
          item.svg = 1;
          break;
        case 2:
          item.svg = 2;
          break;
        case 3:
          item.svg = 3;
          break;
        case 4:
          item.svg = 4;
          break;
        case 5:
          item.svg = 5;
          break;
        case 6:
          item.svg = 6;
          break;
      }

      return item;
    });
    return this.languageService.textsIU.page_profile;
  }
  setTags(id: number) {
    switch (id) {
      case 1:
        this.tagsService.setEventTag(
          'profile_page',
          'profile_info_clicked',
          false,
          true
        );
        break;
      case 2:
        this.tagsService.setEventTag(
          'profile_page',
          'profile_orders_clicked',
          false,
          true
        );
        break;
      case 3:
        this.tagsService.setEventTag(
          'profile_page',
          'profile_adress_clicked',
          false,
          true
        );
        break;
      case 4:
        this.tagsService.setEventTag(
          'profile_page',
          'profile_points_clicked',
          false,
          true
        );
        break;
      case 5:
        this.tagsService.setEventTag(
          'profile_page',
          'profile_config_clicked',
          false,
          true
        );
        break;
      default:
        break;
    }
  }
}
